module.exports = __webpack_public_path__ + "media/images/light_yellow_section_background-8c2645960db4286bb353a23b6b6e3138.svg";